import Card from "components/Card/Card.jsx";
import Confirm from "components/Confirm/Confirm.jsx";
import Button from 'components/CustomButton/CustomButton.jsx';
import { TutorialVideoModal } from "components/TutorialModal/TutorialModal.jsx";
import React, { Component } from "react";
import { Col, Grid, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import { trackPromise } from "react-promise-tracker";
import { style } from "variables/Variables.jsx";
import api from "../../services/api.jsx";
import Store from "./store.jsx";
import Update from "./update.jsx";
import Enrolleds from "./enrolleds.jsx";

class Events extends Component {
  typeApplication = localStorage.getItem("typeApplication");
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      events: [],
      candidates: [],
      candidate: JSON.parse(localStorage.getItem('user')).candidate_id ? JSON.parse(localStorage.getItem('user')).candidate_id : 0,
      isModalVisibleNew: false,
      isModalVisibleEdit: false,
      isModalVisibleEnrolleds: false,
      isComunicationModalVisible: false,
      event: null,
      app: localStorage.getItem('idApp'),
      role: JSON.parse(localStorage.getItem('user')).role,
      callback: undefined,
      text: '',
      confirm: false,
    };
  }
  // ciclo de vida do componente
  componentDidMount() {
    if (this.state.role === "candidate")
      this.loadEvents(this.state.candidate);
    if (this.state.role === "coordinator" || this.state.role === "advisor")
      this.loadCandidates();
  }
  //edita event
  editEvent(event) {
    this.setState({ event: event });
    this.setState({ isModalVisibleEdit: true });
  }
  //edita event
  showEnrollmentEvent(event) {
    this.setState({ event: event });
    this.setState({ isModalVisibleEnrolleds: true });
  }
  // seta no estate o id do candidato selecionado
  changeHandler = (candidateId, candidateName) => {
    this.setState({ [candidateName]: candidateId });
    candidateId ? this.loadEvents(candidateId) : this.setState({ events: [], candidate: 0 });

  };
  // carrega os candidatos
  loadCandidates = async () => {
    const response = await trackPromise(api.get(`/${this.state.app}/candidates?onlyActives=1`));
    this.setState({ candidates: response.data.data });
    if (this.typeApplication === 'one' && response.data.data.length > 0) {
      this.setState({ candidate: response.data.data[0].id });
      this.changeHandler(response.data.data[0].id, response.data.data[0].name);
    }
  };
  //load events
  loadEvents = async (idCandidate) => {
    try {
      const response = await trackPromise(api.get(`/${this.state.app}/candidates/${idCandidate}/events`));
      this.setState({ events: response.data.data });
    } catch (e) {
      //this.handleNotificationClick(e.response.data.message, 'error');
    }
  };
  // delete event
  deleteEvent = (idEvent) => {
    trackPromise(api.delete(`/${this.state.app}/candidates/${this.state.candidate}/events/${idEvent}`))
      .then(response => {
        this.loadEvents(this.state.candidate);
        this.handleNotificationClick('Evento excluido com sucesso!', 'success');
      })
      .catch((error) => {
        console.log(error.message);
        this.handleNotificationClick('Erro na exclusão do evento! Tente novamente!', 'error');
      });
  };
  // set faleria ** funcao nao termindada**
  setGallerie = (id) => {

  };
  // componente de notificacao
  handleNotificationClick = (message, color) => {
    this.refs.notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-info" />,
      message: (
        <div>
          {message}
        </div>
      ),
      level: color,
      position: 'tr',
      autoDismiss: 5,
      dismissible: true
    });
  };

  openComunicationModal = () => {
    this.setState({ isComunicationModalVisible: true });
  };
  // componente de renderezação
  render() {
    const { events, isModalVisibleEdit, candidates, candidate, role, isModalVisibleNew, isModalVisibleEnrolleds, isComunicationModalVisible } = this.state;

    const remove = (<Tooltip id="remove_tooltip">Excluir</Tooltip>);
    const edit = (<Tooltip id="edit_tooltip">Editar</Tooltip>);

    return (
      <>
        <div className="content">
          <NotificationSystem ref="notificationSystem" style={style} />
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Button style={{ marginTop: "15px", marginRight: "15px" }} disabled={!candidate} title="cadastrar novo evento" bsStyle="primary" fixMargin pullRight fill onClick={() => this.setState({ isModalVisibleNew: true })}>  <i className="fa fa-plus"></i> Novo Evento</Button>
                <Card
                  title="Eventos"
                  extraTitleContent={
                    <i
                      className="fa fa-question-circle"
                      style={{ fontSize: "18px", cursor: "pointer" }}
                      title="Assista ao vídeo tutorial dessa área"
                      onClick={this.openComunicationModal}
                    />
                  }
                  category="Eventos cadastrados de um candidato"
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <>
                      {(role === "coordinator" || role === "advisor") &&
                        <form >
                          <div className="form-group">
                            <label className="col-sm-2 col-form-label">
                              Selecione o candidato:
                            </label>
                            <div className="col-sm-10">
                              <select
                                name="candidate"
                                value={candidate}
                                onChange={(e) => this.changeHandler(e.target.value, e.target.name)}
                                className="form-control"
                                disabled={this.typeApplication === 'one'}
                              >
                                {this.typeApplication === 'one' ? null : <option value="">-</option>}
                                {candidates.map(candidate => (
                                  <option key={candidate.id} value={candidate.id}>{candidate.name}</option>
                                ))}
                              </select>
                            </div>


                          </div>
                        </form>
                      }
                      <Table striped hover>
                        <thead>
                          <tr>
                            <th>Imagem</th>
                            <th>Título</th>
                            <th>Local</th>
                            <th>Data</th>
                            <th>Horário</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            events.map(event => (
                              <tr key={event.id}>
                                <td><img className="img-list" src={event.link_image_header} alt={event.link_image_header} /></td>
                                <td>{event.title}</td>
                                <td>{event.place}</td>
                                <td>{event.occurs_date}</td>
                                <td>{event.occurs_time}</td>
                                <td>
                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <Button
                                      bsStyle="info"
                                      simple
                                      type="button"
                                      bsSize="xs"
                                      onClick={() => this.editEvent(event)}
                                    >
                                      <i className="fa fa-edit"></i>
                                      Editar
                                    </Button>
                                  </OverlayTrigger>
                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <Button
                                      bsStyle="danger"
                                      simple
                                      type="button"
                                      bsSize="xs"
                                      onClick={() => this.setState({
                                        callback: () => this.deleteEvent(event.id),
                                        text: `excluir o evento ${event.name}`,
                                        confirm: true
                                      })}
                                    >
                                      <i className="fa fa-times" />
                                      Excluir
                                    </Button>
                                  </OverlayTrigger>

                                  {event.slots ? <OverlayTrigger placement="top" overlay={
                                    <Tooltip id="enrolled_tooltip">
                                      {event.slots ? 'Ver interessados' : 'Listagem de interessados não disponível'}
                                    </Tooltip>
                                  }>
                                    <Button
                                      bsStyle="success"
                                      simple
                                      type="button"
                                      bsSize="xs"
                                      onClick={() => this.showEnrollmentEvent(event)}
                                      disabled={!event.slots}
                                    >
                                      <i className="fa fa-users"></i>
                                      Ver interessados
                                    </Button>
                                  </OverlayTrigger> : null}
                                </td>
                              </tr>
                            ))
                          }

                        </tbody>
                      </Table>

                      {isModalVisibleEdit && <Update onClose={() => { this.setState({ isModalVisibleEdit: false }); this.loadEvents(this.state.candidate); }} event={this.state.event} idCandidato={this.state.candidate} />}
                      {isModalVisibleNew && <Store onClose={() => { this.setState({ isModalVisibleNew: false }); this.loadEvents(this.state.candidate); }} idCandidato={this.state.candidate} />}
                      {isModalVisibleEnrolleds && (
                        <Enrolleds
                          onClose={() => {
                            this.setState({ isModalVisibleEnrolleds: false });
                            this.loadEvents(this.state.candidate);
                          }}
                          event={this.state.event}
                        />
                      )}

                    </>
                  }
                />
              </Col>
            </Row>
          </Grid>
        </div>
        <TutorialVideoModal isOpen={isComunicationModalVisible}
          onClose={() => this.setState({ isComunicationModalVisible: false })}
          link={"https://www.youtube.com/embed/lV-IKFdVjzI?si=huI0YXaVDx973TxL"}
          title={"Notícias, eventos e pesquisas"}
          linkTitle={"Área de comunicação"} />
        <Confirm
          show={this.state.confirm}
          close={() => this.setState({
            confirm: false,
            callback: undefined,
            text: ''
          })}
          callback={this.state.callback}
          text={this.state.text}
        />
      </>
    );
  }
}

export default Events;
